export default __webpack_public_path__ + "static/media/Arpit.4ac5f448.jpeg";